import React, { useEffect, useState } from 'react'
import { unstable_HistoryRouter as HistoryRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import history from './history'
import { getAccountSettings } from 'Selectors/account'

import Home from './containers/Home'
import TestBot from './containers/TestBot'

import AppLoader from 'Layout/AppLoader'

// new ui
import './b/styles.scss'
import Signup from './b/pages/public/Signup'
import VerifyAccount from './b/pages/public/VerifyAccount'
import Login from './b/pages/public/Login'
import Join from './b/pages/public/Join'
import ResetPassword from './b/pages/public/ResetPassword'
import ChangePassword from './b/pages/public/SetNewPassword'
import ProtectedPages from './b/pages/protected'
import VerifyTranscriptEmail from './b/pages/public/VerifyTranscriptEmail'

import { useGetCsrfTokenQuery } from 'Services/me'

import { setCsrfToken } from 'Actions/app'

const getStorageItem = (k) => JSON.parse(localStorage.getItem(k))

const RequireAuth = ({ children }) => {
  const location = useLocation()
  const isAuthenticated = getStorageItem('auth')

  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to='/login' state={{ from: location }} replace />
  }

  return children
}

const PublicAuthCheck = ({ children }) => {
  const isAuthenticated = getStorageItem('auth')

  if (isAuthenticated) {
    return <Navigate to='/b/dashboard' replace />
  }

  return children
}

// Prevents users with new_ui from accessing old ui
const NewUiProtectedRoute = ({ children }) => {
  const accountSettings = useSelector(getAccountSettings)
  const location = useLocation()

  if (accountSettings.new_ui && location.pathname.indexOf('/b') === -1) {
    return <Navigate to='/b' replace />
  }

  return children
}

const ProtectedNewUI = () => {
  const csrfData = useGetCsrfTokenQuery()

  const [showLoader, setShowLoader] = useState(true)

  const dispatch = useDispatch()

  useEffect(() => {
    if (csrfData.isSuccess && csrfData.status === 'fulfilled') {
      const { data } = csrfData
      dispatch(setCsrfToken({ token: data.csrf_token }))
      setShowLoader(false)
    }

    if (csrfData.isError) {
      setShowLoader(false)
    }
  }, [dispatch, csrfData])

  return (
    <AppLoader isLoading={showLoader}>
      <RequireAuth>
        <ProtectedPages />
      </RequireAuth>
    </AppLoader>
  )
}

const ProtectedHome = () => {
  return (
    <RequireAuth>
      <NewUiProtectedRoute>
        <Home />
      </NewUiProtectedRoute>
    </RequireAuth>
  )
}

function App() {
  return (
    <HistoryRouter history={history}>
      <Routes>
        <Route path='signup/*' element={<Signup />} />
        <Route
          path='login'
          element={
            <PublicAuthCheck>
              <Login />
            </PublicAuthCheck>
          }
        />
        <Route path='reset-password/*' element={<ResetPassword />} />
        <Route path='set-new-password/:token' element={<ChangePassword />} />
        <Route path='verify/:token' element={<VerifyAccount />} />
        <Route path='verify-transcript-email/:token' element={<VerifyTranscriptEmail />} />
        <Route path='join/:token' element={<Join />} />
        <Route path='test/:embed_token' element={<TestBot />} />
        <Route path='b/*' element={<ProtectedNewUI />} />
        <Route path='/*' element={<ProtectedHome />} />
        <Route path='*' element={<Navigate to='login' />} />
        <Route index element={<Navigate to='login' />} />
      </Routes>
    </HistoryRouter>
  )
}

export default App
